/* eslint-disable vue/require-v-for-key */
/* eslint-disable vue/require-default-prop */
<template>
  <div class="container">
    <vue-html2pdf style="display: none" :show-layout="false" :float-layout="true" :enable-download="false"
      :preview-modal="false" :paginate-elements-by-height="1400" :pdf-quality="1" pdf-format="a4"
      pdf-orientation="portrait" pdf-content-width="100%" :html-to-pdf-options="htmlToPdfOptions"
      :manual-pagination="false" @beforeDownload="beforeDownload($event)" @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)" ref="html2Pdf">
      <section slot="pdf-content">
        <div v-if="empresa.id_empresa_sistema == 70">
          <receitaCeagesp :receita="receita" :empresa="empresa" :isSignature="isSignature"></receitaCeagesp>
        </div>
        <div v-else-if="receita.estado.includes('Paraná')">
          <receitaPr :receita="receita" :empresa="empresa" :isSignature="isSignature"></receitaPr>
        </div>
        <div v-else-if="receita.complementar">
          <receitaComplementar :receita="receita" :empresa="empresa" :isSignature="isSignature"></receitaComplementar>
        </div>
        <div v-else-if="receita.itens.length == 14">
          <receita14Item :receita="receita" :empresa="empresa" :isSignature="isSignature"></receita14Item>
        </div>
        <div v-else-if="receita.itens.length == 13">
          <receita13Item :receita="receita" :empresa="empresa" :isSignature="isSignature"></receita13Item>
        </div>
        <div v-else-if="receita.itens.length == 12">
          <receita12Item :receita="receita" :empresa="empresa" :isSignature="isSignature"></receita12Item>
        </div>
        <div v-else-if="receita.itens.length == 11">
          <receita11Item :receita="receita" :empresa="empresa" :isSignature="isSignature"></receita11Item>
        </div>
        <div v-else-if="receita.itens.length == 10">
          <receita10Item :receita="receita" :empresa="empresa" :isSignature="isSignature"></receita10Item>
        </div>
        <div v-else-if="receita.itens.length == 9">
          <receita9Item :receita="receita" :empresa="empresa" :isSignature="isSignature"></receita9Item>
        </div>
        <div v-else-if="receita.itens.length == 8">
          <receita8Item :receita="receita" :empresa="empresa" :isSignature="isSignature"></receita8Item>
        </div>
        <div v-else-if="receita.itens.length == 7">
          <receita7Item :receita="receita" :empresa="empresa" :isSignature="isSignature"></receita7Item>
        </div>
        <div v-else-if="receita.itens.length == 6">
          <receita6Item :receita="receita" :empresa="empresa" :isSignature="isSignature"></receita6Item>
        </div>
        <div v-else-if="receita.itens.length == 5">
          <receita5Item :receita="receita" :empresa="empresa" :isSignature="isSignature"></receita5Item>
        </div>
        <div v-else-if="receita.itens.length > 2">
          <receita4Item :receita="receita" :empresa="empresa" :isSignature="isSignature"></receita4Item>
        </div>
        <div v-else>
          <receita1Item :receita="receita" :empresa="empresa" :isSignature="isSignature"></receita1Item>
        </div>
        <!-- <div class="html2pdf__page-break"></div> -->
        <h1><b>RECEITA AGRONÔMICA - INFORMAÇÕES COMPLEMENTARES</b></h1>
        <h3><b>LEIA ATENTAMENTE ANTES DE INICIAR O MANUSEIO</b></h3>
        <header class="header-page2">
          <div>
            <p>
              <b>{{ receita.profissao }}:</b> {{ receita.nomeAgronomo }}
            </p>
            <p v-if="receita.artImpressao !== null && receita.artImpressao.length > 0
            ">
              <b>CFTA:</b>{{ receita.crea }}
            </p>
            <p v-else> <b>CREA:</b>{{ receita.crea }} </p>
            <p>
              <b>Endereço:</b> {{ receita.enderecoEmpresa }}
              {{ receita.municipioEmpresa }} - {{ receita.estadoEmpresa }}
            </p>
          </div>
          <div>
            <p> <b>N° da Receita:</b> {{ receita.ultimaReceitaEmitida }} </p>
            <p> <b>N° da N.F:</b> {{ receita.nf }} </p>
            <p> <b>Vinculada à ART N°.:</b> {{ receita.artVinculada }} </p>
          </div>
        </header>
        <h3><b>PRECAUÇÕES DE USO E CUIDADOS COM O MEIO AMBIENTE:</b></h3>
        <p class="p26 ft12"><span class="ft0">1.</span><span class="ft14">Leia e siga as instruções do rótulo e da bula
            do
            produto, antes de
            abrir a embalagem;</span></p>
        <p class="p27 ft12"><span class="ft0">2.</span><span class="ft14">Use o equipamento de proteção individual
            (máscara, luvas, botas,
            boné árabeou assemelhado, óculos e roupas de mangas longas)
            recomendado;</span></p>
        <p class="p27 ft12"><span class="ft0">3.</span><span class="ft14">Nunca coma, nem fume oubeba durante a
            manipulação de agrotóxicos;</span></p>
        <p class="p27 ft12"><span class="ft0">4.</span><span class="ft14">Não aplique agrotóxicos com condições
            climáticas
            adversas (vento forte, temperatura elevada, baixa umidade do ar, etc.);</span></p>
        <p class="p27 ft12">5.Nunca desentupa bicos pulverizadores com a boca;</p>
        <p class="p28 ft12"><span class="ft0">6.</span><span class="ft14">Verifique se os equipamentos de aplicação
            estão
            em boas condições de uso, sem vazamento e bem calibrados;</span></p>
        <p class="p27 ft12"><span class="ft0">7.</span><span class="ft14">Os agrotóxicos somente devem ser aplicados por
            pessoas devidamente
            treinadas;</span></p>
        <p class="p27 ft12">8.Guarde os agrotóxicos bem fechados, em depósito especial, longe das crianças, dos animais
          e
          dos alimentos;</p>
        <p class="p27 ft12"><span class="ft0">9.</span><span class="ft14">Nunca abasteça e nem lave o pulverizador
            diretamente nas fontes deágua. Use tanques ou reservatórios especiais;</span></p>
        <p class="p29 ft12"><span class="ft0">10.</span><span class="ft15">Nunca despeje os restos de calda dos
            equipamentos de pulverização nas fontes e mananciais de água ou em lugares em que as chuvas
            arrastem as sobras para os cursos de água;</span></p>
        <p class="p28 ft12"><span class="ft0">11.</span><span class="ft14">Evite preparar mais calda do que a quantidade
            a
            ser aplicada. Assim, não sobrarão restos;</span></p>
        <p class="p30 ft12"><span class="ft0">12.</span><span class="ft16">Adote medidas de manejo dosolo e controle da
            erosão para evitar que as partículas de solo com agrotóxicos sejam arrastadas para as fontes e mananciais de
            água;</span></p>
        <p class="p31 ft12"><span class="ft0">13.</span><span class="ft14">Não reutilize qualquer tipo de embalagem de
            agrotóxico;</span></p>
        <p class="p32 ft12"><span class="ft0">14.</span><span class="ft16">Embalagens que contenham líquido ou pó
            molhável
            devem ter uma tríplice lavagem, ou seja, devem ser lavadas três vezes com água
            limpa no momento do uso do produto, e a água da lavagem deve ser adicionada ao tanque de
            pulverização;</span>
        </p>
        <p class="p33 ft12">15.Devolva as embalagens vazias, no prazo de até um ano após a compra, para a casa comercial
          onde foram adquiridas ou para os
          postos/centros de coleta indicados.</p>
        <h3><b>PRIMEIROS SOCORROS</b></h3>
        <p style="text-align: justify; text-justify: inter-word">
          {{ receita.itens[0].descPrimeiroSocorroProduto }}
        </p>
        <h3><b>ADVERTÊNCIAS RELACIONADAS COM PROTEÇÃO DO MEIO AMBIENTE</b></h3>
        <p>
          {{ receita.itens[0].meioAmbiente.join(' ') }}
          Aplique somente as doses recomendadas e observe o intervalo de segurança (intervalo entre a última aplicação e
          a
          colheita.
        </p>
        <h3><b>ANTÍDOTO E TRATAMENTO (INFORMAÇÕES PARA USO MÉDICO)</b></h3>
        <p>{{ receita.itens[0].descAntidotoTratamento }}</p>

        <footer class="mt-4" style="border: 2px solid #000; padding: 5px 5px 5px 5px">
          <h1><b>AGRICULTOR, AGROTÓXICO É VENENO</b></h1>
          <p><b>O uso de agrotóxicos fora das recomendações desta receita é da
              sua inteira responsabilidade. Qualquer dúvida, consulte o
              profissional responsável por esta recomendação (receita).</b></p>
        </footer>
        <footer class="footer-receita mt-5"
          :style="empresa.id_empresa_sistema === 50 ? 'display: block;' : 'display:none'">
          <h2>LEIA ATENTAMENTE O RÓTULO E BULA DO PRODUTO. AGRICULTOR, AGROTÓXICO
            É VENENO.</h2>
          <div class="card" :style="receita.is_sign_produtor ? 'display:none;' : 'display:block;'
            ">
            <p>
              <b style="font-size: 10px">Estou ciente das informações contidas nesta receita e seu
                anexo.</b>
            </p>
            <div class="assinatura mt-4 pt-2">
              <p>
                {{ receita.nomeProdutor }}
              </p>
            </div>
            <div class="card-footer-receita mt-2 mb-2">
              <div>
                <p> <b>CPF/CNPJ: </b>{{ receita.cpfCnpjProdutor }} </p>
                <p>
                  <b>Data:</b> {{ formatDate(receita.dataEmissao) }} /
                  <b>Cidade/UF:</b> {{ receita.municipio }} /
                  {{ receita.estado }}
                </p>
              </div>
            </div>
          </div>

          <div :class="receita.is_sign_produtor ? 'card col-6' : 'card'">
            <div v-show="isSignature">
              <img v-if="checkBase64()" height="40" :src="receita.assinatura" alt="assinatura" />
              <label v-else class="sig3 mt-2">{{ receita.assinatura }}</label>
            </div>

            <div class="assinatura mt-4 pt-2">
              <p>{{ receita.nomeAgronomo }}</p>
            </div>
            <div class="card-footer-receita mt-2 mb-2">
              <div>
                <p> <b>Título do profissional:</b> {{ receita.profissao }} </p>
                <p>
                  <b>CPF:</b>{{ receita.cpf }}
                  <span v-if="receita.artImpressao !== null &&
                    receita.artImpressao.length > 0
                  ">
                    <b>CFTA:</b>{{ receita.crea }}
                  </span>
                  <span v-else> <b>CREA:</b>{{ receita.crea }} </span>
                </p>
                <p> </p>
              </div>
            </div>
          </div>
        </footer>
      </section>
    </vue-html2pdf>

    <div v-if="empresa.id_empresa_sistema == 70">
      <header class="header">
        <h2><b>RECEITUÁRIO AGRONÔMICO</b></h2>

        <div class="w-50">
          <img v-if="empresa.logo != undefined" class="logo" :src="`data:image/png;base64, ${empresa.logo}`" />
          <p>
            <b>Receita Nº:</b> {{ receita.ultimaReceitaEmitida }} /
            <b>ART N°:</b> {{ receita.artVinculada }}
          </p>
          <p v-if="receita.artImpressao !== null && receita.artImpressao.length > 0
          ">
            <b>CFTA:</b>{{ receita.crea }} <b>Data:</b>
            {{ formatDate(receita.dataEmissao) }} <b>N.F:</b>{{ receita.nf }}
          </p>
          <p v-else>
            <b>CREA:</b>{{ receita.crea }} <b>Data:</b>
            {{ formatDate(receita.dataEmissao) }} <b>N.F:</b>{{ receita.nf }}
          </p>
        </div>
        <div>
          <p>
            <b>{{ receita.profissao }}:</b> {{ receita.nomeAgronomo }}
          </p>
          <p>
            <b>Endereço:</b> {{ receita.enderecoEmpresa }}
            {{ receita.municipioEmpresa }} - {{ receita.estadoEmpresa }}
          </p>
        </div>
      </header>
      <div class="dashed-box">
        <h2><b>IDENTIFICAÇÃO AGRICULTOR</b></h2>
        <div class="w-100">
          <p>
            <b>Cliente:</b> {{ receita.nomeProdutor }} - <b>CPF/CNPJ:</b>{{ receita.cpfCnpjProdutor }} - <b>Inscrição
              produtor:</b>{{ receita.inscricaoEstadualProdutor }}
          </p>
          <p>
            <b>Endereço/Município: </b>{{ receita.endereco }} /
            {{ receita.municipio }} - {{ receita.estado }} / <b>Telefone:</b>{{ receita.telefone }}
          </p>
        </div>
      </div>
      <div v-for="item in receita.itens" :key="item.idReceitaItem">
        <div class="dashed-box">
          <h2><b>DIAGNÓSTICO</b></h2>
          <div class="col-7">
            <div class="mt-2">
              <p>
                <b>Cultura:</b> {{ item.nomeComumCultura }}
                {{ item.nomeCientificoCultura }} - <b>Estágio:</b>
                {{ item.descEpocaAplicCultura }}
              </p>
              <p>
                <b>Diagnóstico:</b> {{ item.nomeComumAlvo }}
                {{ item.nomeCientificoAlvo }} - <b>Estágio:</b>
                {{ item.descEpocaAplicPraga }}
              </p>
              <div v-if="receita.estado.includes('Ceará')">
                <p>
                  <b>Produto Comercial:</b> {{ item.nomeProduto }} <br />
                  <b>Ingrediente Ativo:</b> {{ item.ingredienteAtivo.join(' ') }}<br />
                  <b>Fabricante:</b> {{ item.fabricante }}<br />
                  <b>Formulação:</b> {{ item.formulacao }}
                  <b>Grupo Químico:</b>
                  {{ item.grupoQuimico }}
                  <b>Local aplicação:</b> {{ item.localAplicacao }} /
                  <b>Tipo de Aplicação:</b> {{ item.tipoAplicacao }}
                </p>
              </div>
              <div v-else-if="receita.estado.includes('Paraíba')">
                <p>
                  <b>Produto Comercial:</b> {{ item.nomeProduto }} <br />
                  <b>Ingrediente Ativo:</b> {{ item.ingredienteAtivo.join(' ') }} - ({{ item.tipoProduto }})<br />
                  <b>Fabricante:</b> {{ item.fabricante }}<br />
                  <b>Formulação:</b> {{ item.formulacao }}
                  <b>Grupo Químico:</b>
                  {{ item.grupoQuimico }}
                  <b>Local aplicação:</b> {{ item.localAplicacao }} /
                  <b>Tipo de Aplicação:</b> {{ item.tipoAplicacao }}
                </p>
              </div>
              <div v-else>
                <p><b>Produto Comercial:</b> {{ item.nomeProduto }} <br /></p>
                <p><b>Princípio ativo:</b> {{ item.ingredienteAtivo.join(' ') }}<br /></p>
                <p><b>Formulação:</b> {{ item.formulacao }}<br /></p>
                <p><b>Grupo Químico:</b> {{ item.grupoQuimico }}<br /></p>
                <p><b>Local aplicação:</b> {{ item.localAplicacao }} /
                  <b>Tipo de Aplicação:</b> {{ item.tipoAplicacao }}
                </p>

              </div>
            </div>
          </div>
          <div class="col-5" style="padding: 0 !important; margin: 0 !important">
            <div class="mt-2">
              <p>
                <b>Classe Toxicológica:</b>
                {{ item.classeToxicologicaProduto }}
              </p>
              <p>
                <b>Intervalo de Segurança:</b>
                {{ item.intervaloSeguranca }} dias / <b>Nº de aplicações:</b>
                {{ item.nAplicacoes }}
              </p>
              <p v-if="empresa.id_empresa_sistema == 85 || empresa.id_empresa_sistema == 86"> <b>Quantidade a
                  adquirir:</b> {{ item.unidadeDose.includes('L')
                    || item.unidadeDose.includes('L/ha') ?
                    item.qtdeAdquirir : removerParteInteiraSeZero(item.txtQtdeAdquirir) }} {{ item.unidadeDose.includes('L')
                  ||
                  item.unidadeDose.includes('L/ha') ? '(L)'
                  : item.unidadeDose.includes('g') || item.unidadeDose.includes('g/ha') ? '(g)' : 'kg' }}
              </p>
              <p v-else> <b>Quantidade a adquirir:</b> {{ empresa.id_empresa_sistema === 59 ? item.txtQtdeAdquirir :
                item.qtdeAdquirir }} {{ item.unidade ? item.unidade : '' }}</p>
              <b>Dose:</b> {{ item.dose }} {{ item.unidadeDose }}
              <span v-if="item.volumeCalda > 0"><b>- Calda:</b> {{ item.volumeCalda }}
                {{ item.unidadeCalda }}</span>

              <p
                v-if="item.localAplicacao.includes('Nos grãos') || item.localAplicacao.includes('Sacaria') && !item.formulacao.includes('Fumigante em pastilha, comprimido, sachet')">
                <b class="mt-4">Quantidade tratada: </b> {{ new Intl.NumberFormat('pt-BR').format(item.areaAplicacao) }}
                <span
                  v-if="item.unidadeDose.includes('ton') || item.unidadeDose.includes('toneladas') || item.unidadeDose.includes('g/T')">
                  toneladas</span>
                <span
                  v-else-if="item.formulacao.includes('Fumigante em pastilha, comprimido, sachet') || item.formulacao.includes('Fumigante')">
                  (m³)</span>
              </p>
              <p v-else-if="item.unidadeDose.includes('g/m²')">
                <b class="mt-4">Quantidade tratada (m²): </b> {{ new Intl.NumberFormat().format(item.areaAplicacao) }}
              </p>
              <p v-else>
                <b>Quantidade tratada {{ item.formulacao.includes('Fumigante em pastilha, comprimido, sachet') ||
                  item.formulacao.includes('Fumigante') ? '(m³):' :
                  '(ha)' }}</b> {{ new Intl.NumberFormat('pt-BR').format(item.areaAplicacao) }}


                <span v-if="item.unidadeDose.includes('g/m²') || item.unidadeDose.includes('m²')">
                  m²</span>
                <span
                  v-else-if="item.formulacao.includes('Fumigante em pastilha, comprimido, sachet') || item.formulacao.includes('Fumigante')">
                  (m³)</span>

                <span v-if="item.unidadeDose.includes('g/T')">
                  toneladas</span>
              </p>
            </div>
          </div>
        </div>
        <div style="margin-top: -15px">
          <p>
            <b>Modo / Época de aplicação</b>
            {{ item.descModoAplicacao }}
          </p>
        </div>
        <div>
          <p>
            <b>Equipamento de Proteção Individual (EPI) USO OBRIGATÓRIO</b>
            {{ item.descEpi }}
          </p>
        </div>
        <div>
          <p>
            <b>Precauções de Uso</b>
            {{ item.descPrecaucaoUso }}
          </p>
        </div>
        <div v-if="item.obs">
          <p>
            <b>OBSERVAÇÕES</b>
            {{ item.obs }}
          </p>
        </div>
      </div>
      <div class="dashed-box">
        <h2><b>ORIENTAÇÕES QUANTO AO MANEJO INTEGRADO DE PRAGAS E DE RESISTÊNCIA</b></h2>
        <p>
          Realizar o manejo integrado de pragas e resistência. Adotar medidas
          favoráveis que visem a redução ou o controle populacional do problema
          fitossanitário compondo um programa de manejo integrado
        </p>
      </div>
      <div class="dashed-box">
        <h2><b>DESTINAÇÃO FINAL DOS RESÍDUOS E EMBALAGENS VAZIAS</b></h2>
        <p>
          É proibido reutilizar as embalagens de agrotóxicos e afins. As
          embalagens rígidas que contiverem formulações miscíveis ou dispersíveis
          em água deverão ser submetidas pelo usuário à operação de tríplice
          lavagem, ou tecnologia equivalente, conforme normas técnicas oriundas
          dos órgãos competentes e orientação constante de seus rótulos e bulas.
          Os usuários deverão efetuar a devolução das embalagens vazias em postos
          ou centros de recolhimentos, de acordo com as instruções previstas nas
          respectivas bulas, no prazo de até um ano, contado da data de compra.
          (Lei n. 9.974/00, Decreto Federal n.° 4.074/02). </p><b>Local para entrega das embalagens:</b>
        {{
          configuracao.frase_unidade_recebimento == undefined ||
            configuracao.frase_unidade_recebimento.length == 0
            ? receita.unidRecebimento
            : configuracao.frase_unidade_recebimento
        }}
      </div>
      <footer class="footer-receita" :style="receita.itens == 1 ? 'margin-top: 100px;' : 'margin-top: 40px;'">
        <h2>LEIA ATENTAMENTE O RÓTULO E BULA DO PRODUTO. AGRICULTOR, AGROTÓXICO É
          VENENO.</h2>
        <div class="card" :style="receita.is_sign_produtor ? 'display:none;' : 'display:block;'">
          <p>
            <b>Estou ciente das informações contidas nesta receita e seu anexo.</b>
          </p>
          <div class="assinatura mt-4 pt-2">
            <p>
              <b>{{ receita.nomeProdutor }}</b>
            </p>
          </div>
          <div class="card-footer-receita">
            <div>
              <p> <b>CPF/CNPJ: </b>{{ receita.cpfCnpjProdutor }} </p>
              <p>
                <b>Data:</b> {{ formatDate(receita.dataEmissao) }} /
                <b>Cidade/UF:</b> {{ receita.municipio }} /
                {{ receita.estado }}
              </p>
            </div>
          </div>
        </div>

        <div :class="receita.is_sign_produtor ? 'card col-6' : 'card'">
          <div v-show="isSignature">
            <img v-if="checkBase64()" height="40" :src="receita.assinatura" alt="assinatura" />
            <label v-else class="sig3 mt-2">{{ receita.assinatura }}</label>
          </div>

          <div class="assinatura mt-4 pt-2">
            <p>{{ receita.nomeAgronomo }}</p>
          </div>
          <div class="card-footer-receita">
            <div>
              <p> <b>Título do profissional:</b> {{ receita.profissao }} </p>
              <p>
                <b>CPF:</b>{{ receita.cpf }}
                <span v-if="receita.artImpressao !== null &&
                  receita.artImpressao.length > 0
                ">
                  <b>CFTA:</b>{{ receita.crea }}
                </span>
                <span v-else> <b>CREA:</b>{{ receita.crea }} </span>
              </p>
              <p> </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <div v-else-if="empresa.id_empresa_sistema == 101">
      <header class="header">
        <h2><b>RECEITUÁRIO AGRONÔMICO</b></h2>

        <div class="w-50">
          <img v-if="empresa.logo != undefined" class="logo" :src="`data:image/png;base64, ${empresa.logo}`" />
          <p>
            <b>Receita Nº:</b> {{ receita.ultimaReceitaEmitida }} /
            <b>ART N°:</b> {{ receita.artVinculada }}
          </p>
          <p v-if="receita.artImpressao !== null && receita.artImpressao.length > 0
          ">
            <b>CFTA:</b>{{ receita.crea }} <b>Data:</b>
            {{ formatDate(receita.dataEmissao) }} <b>N.F:</b>{{ receita.nf }}
          </p>
          <p v-else>
            <b>CREA:</b>{{ receita.crea }} <b>Data:</b>
            {{ formatDate(receita.dataEmissao) }} <b>N.F:</b>{{ receita.nf }}
          </p>
        </div>
        <div>
          <p>
            <b>{{ receita.profissao }}:</b> {{ receita.nomeAgronomo }}
          </p>
          <p>
            <b>Endereço:</b> {{ receita.enderecoEmpresa }}
            {{ receita.municipioEmpresa }} - {{ receita.estadoEmpresa }}
          </p>
        </div>
      </header>
      <div class="dashed-box">
        <h2><b>IDENTIFICAÇÃO AGRICULTOR</b></h2>
        <div class="w-100">
          <p>
            <b>Cliente:</b> {{ receita.nomeProdutor }} - <b>CPF/CNPJ:</b>{{ receita.cpfCnpjProdutor }} - <b>Inscrição
              produtor:</b>{{ receita.inscricaoEstadualProdutor }}
          </p>
          <p>
            <b>Endereço/Município: </b>{{ receita.endereco }} /
            {{ receita.municipio }} - {{ receita.estado }} / <b>Telefone:</b>{{ receita.telefone }}
          </p>
        </div>
      </div>
      <div v-for="item in receita.itens" :key="item.idReceitaItem">
        <div class="dashed-box">
          <h2><b>DIAGNÓSTICO</b></h2>
          <div class="col-7">
            <div class="mt-2">
              <p>
                <b>Cultura:</b> {{ item.nomeComumCultura }}
                {{ item.nomeCientificoCultura }} - <b>Estágio:</b>
                {{ item.descEpocaAplicCultura }}
              </p>
              <p>
                <b>Diagnóstico:</b> {{ item.nomeComumAlvo }}
                {{ item.nomeCientificoAlvo }} - <b>Estágio:</b>
                {{ item.descEpocaAplicPraga }}
              </p>
              <div>
                <p><b>Produto Comercial:</b> {{ item.nomeProduto }} <br /></p>
                <p><b>Princípio ativo:</b> {{ item.ingredienteAtivo.join(' ') }}<br /></p>
                <p><b>Formulação:</b> {{ item.formulacao }}<br /></p>
                <p><b>Grupo Químico:</b> {{ item.grupoQuimico }}<br /></p>
                <p><b>Local aplicação:</b> {{ item.localAplicacao }} /
                  <b>Tipo de Aplicação:</b> {{ item.tipoAplicacao }}
                  <b>Modalidade de Aplicação:</b> {{ item.tipoAplicacao }} ({{ getCategoria(item.tipoAplicacao) }})
                </p>


              </div>
            </div>
          </div>
          <div class="col-5" style="padding: 0 !important; margin: 0 !important">
            <div class="mt-2">
              <p>
                <b>Classe Toxicológica:</b>
                {{ item.classeToxicologicaProduto }}
              </p>
              <p>
                <b>Intervalo de Segurança:</b>
                {{ item.intervaloSeguranca }} dias / <b>Nº de aplicações:</b>
                {{ item.nAplicacoes }}
              </p>
              <p v-if="empresa.id_empresa_sistema == 85 || empresa.id_empresa_sistema == 86"> <b>Quantidade a
                  adquirir:</b> {{ item.unidadeDose.includes('L')
                    || item.unidadeDose.includes('L/ha') ?
                    item.qtdeAdquirir : removerParteInteiraSeZero(item.txtQtdeAdquirir) }} {{ item.unidadeDose.includes('L')
                  ||
                  item.unidadeDose.includes('L/ha') ? '(L)'
                  : item.unidadeDose.includes('g') || item.unidadeDose.includes('g/ha') ? '(g)' : 'kg' }}
              </p>
              <p v-else> <b>Quantidade a adquirir:</b> {{ empresa.id_empresa_sistema === 59 ? item.txtQtdeAdquirir :
                item.qtdeAdquirir }} {{ item.unidade ? item.unidade : '' }}</p>
              <b>Dose:</b> {{ item.dose }} {{ item.unidadeDose }}
              <span v-if="item.volumeCalda > 0"><b>- Calda:</b> {{ item.volumeCalda }}
                {{ item.unidadeCalda }}</span>

              <p
                v-if="item.localAplicacao.includes('Nos grãos') || item.localAplicacao.includes('Sacaria') && !item.formulacao.includes('Fumigante em pastilha, comprimido, sachet')">
                <b class="mt-4">Quantidade tratada: </b> {{ new Intl.NumberFormat('pt-BR').format(item.areaAplicacao) }}
                <span
                  v-if="item.unidadeDose.includes('ton') || item.unidadeDose.includes('toneladas') || item.unidadeDose.includes('g/T')">
                  toneladas</span>
                <span
                  v-else-if="item.formulacao.includes('Fumigante em pastilha, comprimido, sachet') || item.formulacao.includes('Fumigante')">
                  (m³)</span>
              </p>
              <p v-else-if="item.unidadeDose.includes('g/m²')">
                <b class="mt-4">Quantidade tratada (m²): </b> {{ new Intl.NumberFormat().format(item.areaAplicacao) }}
              </p>
              <p v-else>
                <b>Quantidade tratada {{ item.formulacao.includes('Fumigante em pastilha, comprimido, sachet') ||
                  item.formulacao.includes('Fumigante') ? '(m³):' :
                  '(ha)' }}</b> {{ new Intl.NumberFormat('pt-BR').format(item.areaAplicacao) }}


                <span v-if="item.unidadeDose.includes('g/m²') || item.unidadeDose.includes('m²')">
                  m²</span>
                <span
                  v-else-if="item.formulacao.includes('Fumigante em pastilha, comprimido, sachet') || item.formulacao.includes('Fumigante')">
                  (m³)</span>

                <span v-if="item.unidadeDose.includes('g/T')">
                  toneladas</span>
              </p>
            </div>
          </div>
        </div>
        <div style="margin-top: -15px">
          <p>
            <b>Modo / Época de aplicação</b>
            {{ item.descModoAplicacao }}
          </p>
        </div>
        <div>
          <p>
            <b>Equipamento de Proteção Individual (EPI) USO OBRIGATÓRIO</b>
            {{ item.descEpi }}
          </p>
        </div>
        <div>
          <p>
            <b>Precauções de Uso</b>
            {{ item.descPrecaucaoUso }}
          </p>
        </div>
        <div v-if="item.obs">
          <p>
            <b>OBSERVAÇÕES</b>
            {{ item.obs }}
          </p>
        </div>
      </div>
      <div class="dashed-box mt-2">
        <h2><b>DISTÂNCIAS MÍNIMAS PARA A APLICAÇÃO DE AGROTÓXICOS</b></h2>
        <p class="mt-1"><b>Art. 1º</b> O uso de agrotóxicos na agropecuária deve ser precedido de receituário agronômico
          prescrito
          por profissional habilitado, observada a tecnologia da aplicação nele prevista, as orientações constantes em
          rótulo ou bula do produto e pertinentes normas de defesa agropecuária.</p>

        <p><b>Art. 2°</b> É vedada a aplicação aérea de agrotóxicos em áreas situadas a uma distância mínima de:<br>
          <b>I –</b> 500m de mananciais de captação de água, núcleos populacionais, escolas, habitações e locais de
          recreação;<br>
          <b>II –</b> 250m de mananciais de água, moradias isoladas e culturas suscetíveis a danos.
        </p>

        <p><b>Art. 3º</b> Será permitida a aplicação de agrotóxicos nas lavouras em relação aos locais do art. 2º, se
          efetuada:<br>
          <b>I –</b> Por atomizadores ou canhões, numa distância mínima de 250m;<br>
          <b>II –</b> Por aparelhos costais, tratorizados de barra ou drones (ARP), numa distância mínima de 50m.
        </p>

        <p><b>Art. 4º</b> Aplicações somente poderão ser feitas quando a direção do vento não implicar em deriva de
          agrotóxicos para os locais do art. 2º.</p>

        <p><b>Art. 5º</b> O descumprimento desta Portaria sujeitará o infrator às penalidades previstas na <b>Lei
            Federal nº 7.802/1989</b>, no <b>Decreto Federal nº 4.074/2002</b>, na <b>Lei Estadual nº 7.827/1983</b> e
          no <b>Decreto Estadual nº 3.876/1984</b>.</p>

      </div>
      <div class="dashed-box mt-2">
        <h2><b>ORIENTAÇÕES QUANTO AO MANEJO INTEGRADO DE PRAGAS E DE RESISTÊNCIA</b></h2>
        <p>
          Realizar o manejo integrado de pragas e resistência. Adotar medidas
          favoráveis que visem a redução ou o controle populacional do problema
          fitossanitário compondo um programa de manejo integrado
        </p>
      </div>
      <div class="dashed-box">
        <h2><b>DESTINAÇÃO FINAL DOS RESÍDUOS E EMBALAGENS VAZIAS</b></h2>
        <p>
          É proibido reutilizar as embalagens de agrotóxicos e afins. As
          embalagens rígidas que contiverem formulações miscíveis ou dispersíveis
          em água deverão ser submetidas pelo usuário à operação de tríplice
          lavagem, ou tecnologia equivalente, conforme normas técnicas oriundas
          dos órgãos competentes e orientação constante de seus rótulos e bulas.
          Os usuários deverão efetuar a devolução das embalagens vazias em postos
          ou centros de recolhimentos, de acordo com as instruções previstas nas
          respectivas bulas, no prazo de até um ano, contado da data de compra.
          (Lei n. 9.974/00, Decreto Federal n.° 4.074/02). </p><b>Local para entrega das embalagens:</b>
        {{
          configuracao.frase_unidade_recebimento == undefined ||
            configuracao.frase_unidade_recebimento.length == 0
            ? receita.unidRecebimento
            : configuracao.frase_unidade_recebimento
        }}
      </div>
      <footer class="footer-receita" :style="receita.itens == 1 ? 'margin-top: 100px;' : 'margin-top: 40px;'">
        <h2>LEIA ATENTAMENTE O RÓTULO E BULA DO PRODUTO. AGRICULTOR, AGROTÓXICO É
          VENENO.</h2>
        <div class="card" :style="receita.is_sign_produtor ? 'display:none;' : 'display:block;'">
          <p>
            <b>Estou ciente das informações contidas nesta receita e seu anexo.</b>
          </p>
          <div class="assinatura mt-4 pt-2">
            <p>
              <b>{{ receita.nomeProdutor }}</b>
            </p>
          </div>
          <div class="card-footer-receita">
            <div>
              <p> <b>CPF/CNPJ: </b>{{ receita.cpfCnpjProdutor }} </p>
              <p>
                <b>Data:</b> {{ formatDate(receita.dataEmissao) }} /
                <b>Cidade/UF:</b> {{ receita.municipio }} /
                {{ receita.estado }}
              </p>
            </div>
          </div>
        </div>

        <div :class="receita.is_sign_produtor ? 'card col-6' : 'card'">
          <div v-show="isSignature">
            <img v-if="checkBase64()" height="40" :src="receita.assinatura" alt="assinatura" />
            <label v-else class="sig3 mt-2">{{ receita.assinatura }}</label>
          </div>

          <div class="assinatura mt-4 pt-2">
            <p>{{ receita.nomeAgronomo }}</p>
          </div>
          <div class="card-footer-receita">
            <div>
              <p> <b>Título do profissional:</b> {{ receita.profissao }} </p>
              <p>
                <b>CPF:</b>{{ receita.cpf }}
                <span v-if="receita.artImpressao !== null &&
                  receita.artImpressao.length > 0
                ">
                  <b>CFTA:</b>{{ receita.crea }}
                </span>
                <span v-else> <b>CREA:</b>{{ receita.crea }} </span>
              </p>
              <p> </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <div v-else-if="empresa.id_empresa_sistema == 16">
      <header class="header">
        <h2><b>RECEITUÁRIO AGRONÔMICO</b></h2>

        <div class="w-50">
          <img v-if="empresa.logo != undefined" class="logo" :src="`data:image/png;base64, ${empresa.logo}`" />
          <p>
            <b>Receita Nº:</b> {{ receita.ultimaReceitaEmitida }} /
            <b>ART N°:</b> {{ receita.artVinculada }}
          </p>
          <p v-if="receita.artImpressao !== null && receita.artImpressao.length > 0
          ">
            <b>CFTA:</b>{{ receita.crea }} <b>Data:</b>
            {{ formatDate(receita.dataEmissao) }} <b>N.F:</b>{{ receita.nf }}
          </p>
          <p v-else>
            <b>CREA:</b>{{ receita.crea }} <b>Data:</b>
            {{ formatDate(receita.dataEmissao) }} <b>N.F:</b>{{ receita.nf }}
          </p>
        </div>
        <div>
          <p>
            <b>{{ receita.profissao }}:</b> {{ receita.nomeAgronomo }} - CPF: {{ formatCpf(receita.cpf) }}
          </p>
          <p>
            <b>Endereço:</b> {{ receita.enderecoEmpresa }}
            {{ receita.municipioEmpresa }} - {{ receita.estadoEmpresa }}
          </p>
        </div>
      </header>
      <div class="dashed-box">
        <h2><b>IDENTIFICAÇÃO AGRICULTOR</b></h2>
        <div class="w-100">
          <p>
            <b>Cliente:</b> {{ receita.nomeProdutor }} - <b>CPF/CNPJ:</b>{{ receita.cpfCnpjProdutor }} - <b>Inscrição
              produtor:</b>{{ receita.inscricaoEstadualProdutor }}
          </p>
          <p>
            <b>Endereço/Município: </b>{{ receita.endereco }} /
            {{ receita.municipio }} - {{ receita.estado }} / <b>Telefone:</b>{{ receita.telefone }}
          </p>
        </div>
      </div>
      <div v-for="item in receita.itens" :key="item.idReceitaItem">
        <div class="dashed-box">
          <h2><b>DIAGNÓSTICO</b></h2>
          <div class="col-7">
            <div class="mt-2">
              <p>
                <b>Cultura:</b> {{ item.nomeComumCultura }}
                {{ item.nomeCientificoCultura }} - <b>Estágio:</b>
                {{ item.descEpocaAplicCultura }}
              </p>
              <p>
                <b>Diagnóstico:</b> {{ item.nomeComumAlvo }}
                {{ item.nomeCientificoAlvo }} - <b>Estágio:</b>
                {{ item.descEpocaAplicPraga }}
              </p>
              <div>
                <p><b>Produto Comercial:</b> {{ item.nomeProduto }} <br /></p>
                <p><b>Princípio ativo:</b> {{ item.ingredienteAtivo.join(' ') }}<br /></p>
                <p><b>Formulação:</b> {{ item.formulacao }}<br /></p>
                <p><b>Grupo Químico:</b> {{ item.grupoQuimico }}<br /></p>
                <p><b>Local aplicação:</b> {{ item.localAplicacao }} /
                  <b>Tipo de Aplicação:</b> {{ item.tipoAplicacao }}
                  <b>Modalidade de Aplicação:</b> {{ item.tipoAplicacao }} ({{ getCategoria(item.tipoAplicacao) }})
                </p>


              </div>
            </div>
          </div>
          <div class="col-5" style="padding: 0 !important; margin: 0 !important">
            <div class="mt-2">
              <p>
                <b>Classe Toxicológica:</b>
                {{ item.classeToxicologicaProduto }}
              </p>
              <p>
                <b>Intervalo de Segurança:</b>
                {{ item.intervaloSeguranca }} dias / <b>Nº de aplicações:</b>
                {{ item.nAplicacoes }}
              </p>
              <p v-if="empresa.id_empresa_sistema == 85 || empresa.id_empresa_sistema == 86"> <b>Quantidade a
                  adquirir:</b> {{ item.unidadeDose.includes('L')
                    || item.unidadeDose.includes('L/ha') ?
                    item.qtdeAdquirir : removerParteInteiraSeZero(item.txtQtdeAdquirir) }} {{ item.unidadeDose.includes('L')
                  ||
                  item.unidadeDose.includes('L/ha') ? '(L)'
                  : item.unidadeDose.includes('g') || item.unidadeDose.includes('g/ha') ? '(g)' : 'kg' }}
              </p>
              <p v-else> <b>Quantidade a adquirir:</b> {{ empresa.id_empresa_sistema === 59 ? item.txtQtdeAdquirir :
                item.qtdeAdquirir }} {{ item.unidade ? item.unidade : '' }}</p>
              <b>Dose:</b> {{ item.dose }} {{ item.unidadeDose }}
              <span v-if="item.volumeCalda > 0"><b>- Calda:</b> {{ item.volumeCalda }}
                {{ item.unidadeCalda }}</span>

              <p
                v-if="item.localAplicacao.includes('Nos grãos') || item.localAplicacao.includes('Sacaria') && !item.formulacao.includes('Fumigante em pastilha, comprimido, sachet')">
                <b class="mt-4">Quantidade tratada: </b> {{ new Intl.NumberFormat('pt-BR').format(item.areaAplicacao) }}
                <span
                  v-if="item.unidadeDose.includes('ton') || item.unidadeDose.includes('toneladas') || item.unidadeDose.includes('g/T')">
                  toneladas</span>
                <span
                  v-else-if="item.formulacao.includes('Fumigante em pastilha, comprimido, sachet') || item.formulacao.includes('Fumigante')">
                  (m³)</span>
              </p>
              <p v-else-if="item.unidadeDose.includes('g/m²')">
                <b class="mt-4">Quantidade tratada (m²): </b> {{ new Intl.NumberFormat().format(item.areaAplicacao) }}
              </p>
              <p v-else>
                <b>Quantidade tratada {{ item.formulacao.includes('Fumigante em pastilha, comprimido, sachet') ||
                  item.formulacao.includes('Fumigante') ? '(m³):' :
                  '(ha)' }}</b> {{ new Intl.NumberFormat('pt-BR').format(item.areaAplicacao) }}


                <span v-if="item.unidadeDose.includes('g/m²') || item.unidadeDose.includes('m²')">
                  m²</span>
                <span
                  v-else-if="item.formulacao.includes('Fumigante em pastilha, comprimido, sachet') || item.formulacao.includes('Fumigante')">
                  (m³)</span>

                <span v-if="item.unidadeDose.includes('g/T')">
                  toneladas</span>
              </p>
            </div>
          </div>
        </div>
        <div style="margin-top: -15px">
          <p>
            <b>Modo / Época de aplicação</b>
            {{ item.descModoAplicacao }}
          </p>
        </div>
        <div>
          <p>
            <b>Equipamento de Proteção Individual (EPI) USO OBRIGATÓRIO</b>
            {{ item.descEpi }}
          </p>
        </div>
        <div>
          <p>
            <b>Precauções de Uso</b>
            {{ item.descPrecaucaoUso }}
          </p>
        </div>
        <div v-if="item.obs">
          <p>
            <b>OBSERVAÇÕES</b>
            {{ item.obs }}
          </p>
        </div>
      </div>
      <div class="dashed-box mt-2">
        <h2><b>DISTÂNCIAS MÍNIMAS PARA A APLICAÇÃO DE AGROTÓXICOS</b></h2>
        <p class="mt-1"><b>Art. 1º</b> O uso de agrotóxicos na agropecuária deve ser precedido de receituário agronômico
          prescrito
          por profissional habilitado, observada a tecnologia da aplicação nele prevista, as orientações constantes em
          rótulo ou bula do produto e pertinentes normas de defesa agropecuária.</p>

        <p><b>Art. 2°</b> É vedada a aplicação aérea de agrotóxicos em áreas situadas a uma distância mínima de:<br>
          <b>I –</b> 500m de mananciais de captação de água, núcleos populacionais, escolas, habitações e locais de
          recreação;<br>
          <b>II –</b> 250m de mananciais de água, moradias isoladas e culturas suscetíveis a danos.
        </p>

        <p><b>Art. 3º</b> Será permitida a aplicação de agrotóxicos nas lavouras em relação aos locais do art. 2º, se
          efetuada:<br>
          <b>I –</b> Por atomizadores ou canhões, numa distância mínima de 250m;<br>
          <b>II –</b> Por aparelhos costais, tratorizados de barra ou drones (ARP), numa distância mínima de 50m.
        </p>

        <p><b>Art. 4º</b> Aplicações somente poderão ser feitas quando a direção do vento não implicar em deriva de
          agrotóxicos para os locais do art. 2º.</p>

        <p><b>Art. 5º</b> O descumprimento desta Portaria sujeitará o infrator às penalidades previstas na <b>Lei
            Federal nº 7.802/1989</b>, no <b>Decreto Federal nº 4.074/2002</b>, na <b>Lei Estadual nº 7.827/1983</b> e
          no <b>Decreto Estadual nº 3.876/1984</b>.</p>

      </div>
      <div class="dashed-box mt-2">
        <h2><b>ORIENTAÇÕES QUANTO AO MANEJO INTEGRADO DE PRAGAS E DE RESISTÊNCIA</b></h2>
        <p>
          Realizar o manejo integrado de pragas e resistência. Adotar medidas
          favoráveis que visem a redução ou o controle populacional do problema
          fitossanitário compondo um programa de manejo integrado
        </p>
      </div>
      <div class="dashed-box">
        <h2><b>DESTINAÇÃO FINAL DOS RESÍDUOS E EMBALAGENS VAZIAS</b></h2>
        <p>
          É proibido reutilizar as embalagens de agrotóxicos e afins. As
          embalagens rígidas que contiverem formulações miscíveis ou dispersíveis
          em água deverão ser submetidas pelo usuário à operação de tríplice
          lavagem, ou tecnologia equivalente, conforme normas técnicas oriundas
          dos órgãos competentes e orientação constante de seus rótulos e bulas.
          Os usuários deverão efetuar a devolução das embalagens vazias em postos
          ou centros de recolhimentos, de acordo com as instruções previstas nas
          respectivas bulas, no prazo de até um ano, contado da data de compra.
          (Lei n. 9.974/00, Decreto Federal n.° 4.074/02). </p><b>Local para entrega das embalagens:</b>
        {{
          configuracao.frase_unidade_recebimento == undefined ||
            configuracao.frase_unidade_recebimento.length == 0
            ? receita.unidRecebimento
            : configuracao.frase_unidade_recebimento
        }}
      </div>
      <footer class="footer-receita" :style="receita.itens == 1 ? 'margin-top: 100px;' : 'margin-top: 40px;'">
        <h2>LEIA ATENTAMENTE O RÓTULO E BULA DO PRODUTO. AGRICULTOR, AGROTÓXICO É
          VENENO.</h2>
        <div class="card" :style="receita.is_sign_produtor ? 'display:none;' : 'display:block;'">
          <p>
            <b>Estou ciente das informações contidas nesta receita e seu anexo.</b>
          </p>
          <div class="assinatura mt-4 pt-2">
            <p>
              <b>{{ receita.nomeProdutor }}</b>
            </p>
          </div>
          <div class="card-footer-receita">
            <div>
              <p> <b>CPF/CNPJ: </b>{{ receita.cpfCnpjProdutor }} </p>
              <p>
                <b>Data:</b> {{ formatDate(receita.dataEmissao) }} /
                <b>Cidade/UF:</b> {{ receita.municipio }} /
                {{ receita.estado }}
              </p>
            </div>
          </div>
        </div>

        <div :class="receita.is_sign_produtor ? 'card col-6' : 'card'">
          <div v-show="isSignature">
            <img v-if="checkBase64()" height="40" :src="receita.assinatura" alt="assinatura" />
            <label v-else class="sig3 mt-2">{{ receita.assinatura }}</label>
          </div>

          <div class="assinatura mt-4 pt-2">
            <p>{{ receita.nomeAgronomo }}</p>
          </div>
          <div class="card-footer-receita">
            <div>
              <p> <b>Título do profissional:</b> {{ receita.profissao }} </p>
              <p>
                <b>CPF:</b>{{ receita.cpf }}
                <span v-if="receita.artImpressao !== null &&
                  receita.artImpressao.length > 0
                ">
                  <b>CFTA:</b>{{ receita.crea }}
                </span>
                <span v-else> <b>CREA:</b>{{ receita.crea }} </span>
              </p>
              <p> </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <div v-else-if="receita.complementar">
      <img v-if="empresa.logo != undefined" class="logo" :src="`data:image/png;base64, ${empresa.logo}`" />
      <header class="header">
        <h2><b>RECEITUÁRIO AGRONÔMICO (COMPLEMENTAR)</b></h2>
        <div class="w-50">
          <p>
            <b>Receita Nº:</b> {{ receita.ultimaReceitaEmitida }} /
            <b>ART N°:</b> {{ receita.artVinculada }}
            <b>Data:</b> {{ formatDate(receita.dataEmissao) }} <b>N.F:</b>{{ receita.nf }}
          </p>
          <p>
            <b>Receita Origem Nº:</b> {{ receita.receitaOrigem }} /
            <b>ART Origem Nº:</b> {{ receita.artOrigem }}
          </p>
        </div>
        <div>
          <p>
            <b>{{ receita.profissao }}:</b> {{ receita.nomeAgronomo }}
            <span v-if="receita.artImpressao !== null && receita.artImpressao.length > 0
            ">
              <b>CFTA:</b> {{ receita.crea }}
            </span>
            <span v-else>
              <b>CREA:</b>{{ receita.crea }}
            </span>
          </p>
          <p>
            <b>Endereço:</b> {{ receita.enderecoEmpresa }}
            {{ receita.municipioEmpresa }} - {{ receita.estadoEmpresa }}
          </p>
        </div>
      </header>
      <div class="dashed-box mt-3">
        <h2><b>IDENTIFICAÇÃO AGRICULTOR</b></h2>
        <div class="w-100">
          <p>
            <b>Cliente:</b> {{ receita.nomeProdutor }} - <b>CPF/CNPJ:</b>{{ receita.cpfCnpjProdutor }} - <b>Inscrição
              produtor:</b>{{ receita.inscricaoEstadualProdutor }}
          </p>
          <p>
            <b>Endereço/Município: </b>{{ receita.endereco }} /
            {{ receita.municipio }} - {{ receita.estado }} / <b>Telefone:</b>{{ receita.telefone }}
          </p>
          <p>
            {{ receita.textcoordenadaDMS }}
          </p>
        </div>
      </div>
      <div v-for="item in receita.itens" :key="item.idReceitaItem">
        <div class="dashed-box">
          <h2><b>DIAGNÓSTICO</b></h2>
          <div>
            <p>
              <b>Cultura:</b> {{ item.nomeComumCultura }}
              {{ item.nomeCientificoCultura }} - <b>Estágio:</b>
              {{ item.descEpocaAplicCultura }}
            </p>
            <p>
              <b>Diagnóstico:</b> {{ item.nomeComumAlvo }}
              {{ item.nomeCientificoAlvo }} - <b>Estágio:</b>
              {{ item.descEpocaAplicPraga }}
            </p>
            <div v-if="receita.estado.includes('Ceará')">
              <p>
                <b>Produto:</b> {{ item.nomeProduto }} ({{
                  item.ingredienteAtivo.join(' ')
                }})<br />

                <b>Fabricante:</b> {{ item.fabricante }}<br />
                <b>Formulação:</b> {{ item.formulacao }}
                <b>Grupo Químico:</b>
                {{ item.grupoQuimico }}
              <p v-if="empresa.id_empresa_sistema == 85 || empresa.id_empresa_sistema == 86"> <b>Quantidade a
                  adquirir:</b> {{
                    item.unidadeDose.includes('L') || item.unidadeDose.includes('L/ha') ?
                      item.qtdeAdquirir : removerParteInteiraSeZero(item.txtQtdeAdquirir) }} {{ item.unidadeDose.includes('L')
                  ||
                  item.unidadeDose.includes('L/ha') ? '(L)'
                  : item.unidadeDose.includes('g') || item.unidadeDose.includes('g/ha') ? '(g)' : 'kg' }}
              </p>
              <p v-else> <b>Quantidade a adquirir:</b> {{ empresa.id_empresa_sistema === 59 ? item.txtQtdeAdquirir :
                item.qtdeAdquirir }} {{ item.unidade ? item.unidade : '' }}</p><br />
              <b>Local aplicação:</b> {{ item.localAplicacao }} /
              <b>Modalidade de Aplicação:</b> {{ empresa.id_empresa_sistema === 82 || empresa.id_empresa_sistema === 111
                ? (item.descEquipamentoAplicacao ||
                  item.tipoAplicacao) : item.tipoAplicacao }}
              </p>
            </div>
            <div v-else-if="receita.estado.includes('Paraíba')">
              <p>
                <b>Produto:</b> {{ item.nomeProduto }} ({{
                  item.ingredienteAtivo.join(' ')
                }}) - {{
                  item.tipoProduto }}<br />

                <b>Fabricante:</b> {{ item.fabricante }}<br />
                <b>Formulação:</b> {{ item.formulacao }}
                <b>Grupo Químico:</b>
                {{ item.grupoQuimico }}
              <p v-if="empresa.id_empresa_sistema == 85 || empresa.id_empresa_sistema == 86"> <b>Quantidade a
                  adquirir:</b> {{
                    item.unidadeDose.includes('L') || item.unidadeDose.includes('L/ha') ?
                      item.qtdeAdquirir : removerParteInteiraSeZero(item.txtQtdeAdquirir) }} {{ item.unidadeDose.includes('L')
                  ||
                  item.unidadeDose.includes('L/ha') ? '(L)'
                  : item.unidadeDose.includes('g') || item.unidadeDose.includes('g/ha') ? '(g)' : 'kg' }}
              </p>
              <p v-else> <b>Quantidade a adquirir:</b> {{ empresa.id_empresa_sistema === 59 ? item.txtQtdeAdquirir :
                item.qtdeAdquirir }} {{ item.unidade ? item.unidade : '' }}</p><br />
              <b>Local aplicação:</b> {{ item.localAplicacao }} /
              <b>Modalidade de Aplicação:</b> {{ empresa.id_empresa_sistema === 82 || empresa.id_empresa_sistema === 111
                ? (item.descEquipamentoAplicacao ||
                  item.tipoAplicacao) : item.tipoAplicacao }}
              </p>
            </div>
            <div v-else>
              <p>
                <b>Produto:</b> {{ item.nomeProduto }} ({{
                  item.ingredienteAtivo.join(' ')
                }})
              </p>
              <p v-if="empresa.id_empresa_sistema == 85 || empresa.id_empresa_sistema == 86"> <b>Quantidade a
                  adquirir:</b> {{
                    item.unidadeDose.includes('L') || item.unidadeDose.includes('L/ha') ?
                      item.qtdeAdquirir : removerParteInteiraSeZero(item.txtQtdeAdquirir) }} {{ item.unidadeDose.includes('L')
                  ||
                  item.unidadeDose.includes('L/ha') ? '(L)'
                  : item.unidadeDose.includes('g') || item.unidadeDose.includes('g/ha') ? '(g)' : 'kg' }}
              </p>
              <p v-else> <b>Quantidade a adquirir:</b> {{ empresa.id_empresa_sistema === 59 ? item.txtQtdeAdquirir :
                item.qtdeAdquirir }} {{ item.unidade ? item.unidade : '' }}</p>
              <p>
                <b>Local aplicação:</b> {{ item.localAplicacao }} /
                <b>Modalidade de Aplicação:</b> {{ empresa.id_empresa_sistema === 82 || empresa.id_empresa_sistema ===
                  111 ? (item.descEquipamentoAplicacao ||
                    item.tipoAplicacao) : item.tipoAplicacao }}
              </p>
            </div>
          </div>
          <div>
            <p>
              <b>Classe Toxicológica:</b> {{ item.classeToxicologicaProduto }}
            </p>
            <p> <b>Número de aplicações:</b> {{ item.nAplicacoes }} </p>
            <p>
              <b>Intervalo de Segurança:</b> {{ item.intervaloSeguranca }} dias
            </p>
            <p>
              <b>{{ getAreaAplicacaoLabel(item) }}:</b>
              {{ new Intl.NumberFormat('pt-BR').format(item.areaAplicacao) }}
              {{ getAreaAplicacaoUnit(item) }}
            </p>
          </div>
        </div>
        <div style="margin-top: -15px">
          <p>
            <b>Modo / Época de aplicação</b>
            {{ item.descModoAplicacao }}
          </p>
        </div>
        <div>
          <p>
            <b>Equipamento de Proteção Individual (EPI) USO OBRIGATÓRIO</b>
            {{ item.descEpi }}
          </p>
        </div>
        <div>
          <p>
            <b>Precauções de Uso</b>
            {{ item.descPrecaucaoUso }}
          </p>
        </div>
        <div v-if="item.obs">
          <p>
            <b>OBSERVAÇÕES</b>
            {{ item.obs }}
          </p>
        </div>
      </div>
      <div class="dashed-box">
        <h2><b>ORIENTAÇÕES QUANTO AO MANEJO INTEGRADO DE PRAGAS E DE RESISTÊNCIA</b></h2>
        <p>
          Realizar o manejo integrado de pragas e resistência. Adotar medidas
          favoráveis que visem a redução ou o controle populacional do problema
          fitossanitário compondo um programa de manejo integrado
        </p>
      </div>
      <div class="dashed-box">
        <h2><b>DESTINAÇÃO FINAL DOS RESÍDUOS E EMBALAGENS VAZIAS</b></h2>
        <p>
          É proibido reutilizar as embalagens de agrotóxicos e afins. As
          embalagens rígidas que contiverem formulações miscíveis ou dispersíveis
          em água deverão ser submetidas pelo usuário à operação de tríplice
          lavagem, ou tecnologia equivalente, conforme normas técnicas oriundas
          dos órgãos competentes e orientação constante de seus rótulos e bulas.
          Os usuários deverão efetuar a devolução das embalagens vazias em postos
          ou centros de recolhimentos, de acordo com as instruções previstas nas
          respectivas bulas, no prazo de até um ano, contado da data de compra.
          (Lei n. 9.974/00, Decreto Federal n.° 4.074/02). </p><b>Local para entrega das embalagens:</b>
        {{
          configuracao.frase_unidade_recebimento == undefined ||
            configuracao.frase_unidade_recebimento.length == 0
            ? receita.unidRecebimento
            : configuracao.frase_unidade_recebimento
        }}
      </div>
      <footer class="footer-receita" :style="receita.itens == 1 ? 'margin-top: 100px;' : 'margin-top: 40px;'">
        <h2>LEIA ATENTAMENTE O RÓTULO E BULA DO PRODUTO. AGRICULTOR, AGROTÓXICO É
          VENENO.</h2>
        <div class="card" :style="receita.is_sign_produtor ? 'display:none;' : 'display:block;'">
          <p>
            <b>Estou ciente das informações contidas nesta receita e seu anexo.</b>
          </p>
          <div class="assinatura mt-4 pt-2">
            <p>
              <b>{{ receita.nomeProdutor }}</b>
            </p>
          </div>
          <div class="card-footer-receita">
            <div>
              <p> <b>CPF/CNPJ: </b>{{ receita.cpfCnpjProdutor }} </p>
              <p>
                <b>Data:</b> {{ formatDate(receita.dataEmissao) }} /
                <b>Cidade/UF:</b> {{ receita.municipio }} /
                {{ receita.estado }}
              </p>
            </div>
          </div>
        </div>
        <div :class="receita.is_sign_produtor ? 'card col-6' : 'card'">
          <div v-show="isSignature">
            <img style="max-width: 50%; height: auto;" v-if="checkBase64()" :src="receita.assinatura"
              alt="assinatura" />
            <label v-else class="sig3 mt-2">{{ receita.assinatura }}</label>
          </div>

          <div class="assinatura">
            <p>{{ receita.nomeAgronomo }}</p>
          </div>
          <div class="card-footer-receita">
            <div>
              <p> <b>Título do profissional:</b> {{ receita.profissao }} </p>
              <p>
                <b>CPF:</b>{{ receita.cpf }}
                <span v-if="receita.artImpressao !== null &&
                  receita.artImpressao.length > 0
                ">
                  <b>CFTA:</b>{{ receita.crea }}
                </span>
                <span v-else> <b>CREA:</b>{{ receita.crea }} </span>
              </p>
              <p> </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <div v-else>
      <header class="header">
        <h2><b>RECEITUÁRIO AGRONÔMICO</b></h2>

        <div class="w-50">
          <img v-if="empresa.logo != undefined" class="logo" :src="`data:image/png;base64, ${empresa.logo}`" />
          <p>
            <b>Receita Nº:</b> {{ receita.ultimaReceitaEmitida }} /
            <b>ART N°:</b> {{ receita.artVinculada }}
          </p>
          <p>
            <b>{{ isAgronomo(receita.profissao) ? 'CREA' : 'CFTA' }}:</b> {{ receita.crea }}
            <b>Data:</b> {{ formatDate(receita.dataEmissao) }}
            <b>N.F:</b> {{ receita.nf }}
          </p>
        </div>
        <div>
          <p>
            <b>{{ receita.profissao }}:</b> {{ receita.nomeAgronomo }}
          </p>
          <p>
            <b>Endereço:</b> {{ receita.enderecoEmpresa }}
            {{ receita.municipioEmpresa }} - {{ receita.estadoEmpresa }}
          </p>
        </div>
      </header>
      <div class="dashed-box">
        <h2><b>IDENTIFICAÇÃO AGRICULTOR</b></h2>
        <div class="w-100">
          <p>
            <b>Cliente:</b> {{ receita.nomeProdutor }} - <b>CPF/CNPJ:</b>{{ receita.cpfCnpjProdutor }} - <b>Inscrição
              produtor:</b>{{ receita.inscricaoEstadualProdutor }}
          </p>
          <p>
            <b>Endereço/Município: </b>{{ receita.endereco }} /
            {{ receita.municipio }} - {{ receita.estado }} / <b>Telefone:</b>{{ receita.telefone }}
          </p>
          <p>
            {{ receita.textcoordenadaDMS }}
          </p>
           <p> <b>Local de aplicação:</b>{{ receita.localAplicacao }} </p>
        </div>
      </div>
      <div v-for="item in receita.itens" :key="item.idReceitaItem">
        <div class="dashed-box">
          <h2><b>DIAGNÓSTICO</b></h2>
          <div>
            <p>
              <b>Cultura:</b> {{ item.nomeComumCultura }}
              {{ item.nomeCientificoCultura }} - <b>Estágio:</b>
              {{ item.descEpocaAplicCultura }}
            </p>
            <p>
              <b>Diagnóstico:</b> {{ item.nomeComumAlvo }}
              {{ item.nomeCientificoAlvo }} - <b>Estágio:</b>
              {{ item.descEpocaAplicPraga }}
            </p>
            <div v-if="receita.estado.includes('Ceará')">
              <p>
                <b>Produto:</b> {{ item.nomeProduto }} ({{
                  item.ingredienteAtivo.join(' ')
                }})<br />

                <b>Fabricante:</b> {{ item.fabricante }}<br />
                <b>Formulação:</b> {{ item.formulacao }}
                <b>Grupo Químico:</b>
                {{ item.grupoQuimico }}
              <p v-if="empresa.id_empresa_sistema == 85 || empresa.id_empresa_sistema == 86"> <b>Quantidade a
                  adquirir:</b> {{
                    item.unidadeDose.includes('L') || item.unidadeDose.includes('L/ha') ?
                      item.qtdeAdquirir : removerParteInteiraSeZero(item.txtQtdeAdquirir) }} {{ item.unidadeDose.includes('L')
                  ||
                  item.unidadeDose.includes('L/ha') ? '(L)'
                  : item.unidadeDose.includes('g') || item.unidadeDose.includes('g/ha') ? '(g)' : 'kg' }}
              </p>
              <p v-else> <b>Quantidade a adquirir:</b> {{ empresa.id_empresa_sistema === 59 ? item.txtQtdeAdquirir :
                item.qtdeAdquirir }} {{ item.unidade ? item.unidade : '' }}</p><br />
              <b>Local aplicação:</b> {{ item.localAplicacao }} /
              <b>Modalidade de Aplicação:</b> {{ empresa.id_empresa_sistema === 82 || empresa.id_empresa_sistema === 111
                ? (item.descEquipamentoAplicacao ||
                  item.tipoAplicacao) : item.tipoAplicacao }}
              </p>
            </div>
            <div v-else-if="receita.estado.includes('Paraíba')">
              <p>
                <b>Produto:</b> {{ item.nomeProduto }} ({{
                  item.ingredienteAtivo.join(' ')
                }}) - {{
                  item.tipoProduto }}<br />

                <b>Fabricante:</b> {{ item.fabricante }}<br />
                <b>Formulação:</b> {{ item.formulacao }}
                <b>Grupo Químico:</b>
                {{ item.grupoQuimico }}
              <p v-if="empresa.id_empresa_sistema == 85 || empresa.id_empresa_sistema == 86"> <b>Quantidade a
                  adquirir:</b> {{
                    item.unidadeDose.includes('L') || item.unidadeDose.includes('L/ha') ?
                      item.qtdeAdquirir : removerParteInteiraSeZero(item.txtQtdeAdquirir) }} {{ item.unidadeDose.includes('L')
                  ||
                  item.unidadeDose.includes('L/ha') ? '(L)'
                  : item.unidadeDose.includes('g') || item.unidadeDose.includes('g/ha') ? '(g)' : 'kg' }}
              </p>
              <p v-else> <b>Quantidade a adquirir:</b> {{ empresa.id_empresa_sistema === 59 ? item.txtQtdeAdquirir :
                item.qtdeAdquirir }} {{ item.unidade ? item.unidade : '' }}</p><br />
              <b>Local aplicação:</b> {{ item.localAplicacao }} /
              <b>Modalidade de Aplicação:</b> {{ empresa.id_empresa_sistema === 82 || empresa.id_empresa_sistema === 111
                ? (item.descEquipamentoAplicacao ||
                  item.tipoAplicacao) : item.tipoAplicacao }}
              </p>
            </div>
            <div v-else>
              <p>
                <b>Produto:</b> {{ item.nomeProduto }} ({{
                  item.ingredienteAtivo.join(' ')
                }})
              </p>
              <p v-if="empresa.id_empresa_sistema == 85 || empresa.id_empresa_sistema == 86"> <b>Quantidade a
                  adquirir:</b> {{
                    item.unidadeDose.includes('L') || item.unidadeDose.includes('L/ha') ?
                      item.qtdeAdquirir : removerParteInteiraSeZero(item.txtQtdeAdquirir) }} {{ item.unidadeDose.includes('L')
                  ||
                  item.unidadeDose.includes('L/ha') ? '(L)'
                  : item.unidadeDose.includes('g') || item.unidadeDose.includes('g/ha') ? '(g)' : 'kg' }}
              </p>
              <p v-else> <b>Quantidade a adquirir:</b> {{ empresa.id_empresa_sistema === 59 ? item.txtQtdeAdquirir :
                item.qtdeAdquirir }} {{ item.unidade ? item.unidade : '' }}</p>
              <p>
                <b>Local aplicação:</b> {{ item.localAplicacao }} /
                <b>Modalidade de Aplicação:</b> {{ empresa.id_empresa_sistema === 82 || empresa.id_empresa_sistema ===
                  111 ? (item.descEquipamentoAplicacao ||
                    item.tipoAplicacao) : item.tipoAplicacao }}
              </p>
            </div>
          </div>
          <div>
            <p>
              <b>Classe Toxicológica:</b> {{ item.classeToxicologicaProduto }}
            </p>
            <p> <b>Número de aplicações:</b> {{ item.nAplicacoes }} </p>
            <p>
              <b>Intervalo de Segurança:</b> {{ item.intervaloSeguranca }} dias
            </p>
            <p>
              <b>{{ getAreaAplicacaoLabel(item) }}:</b>
              {{ new Intl.NumberFormat('pt-BR').format(item.areaAplicacao) }}
              {{ getAreaAplicacaoUnit(item) }}
            </p>
          </div>
        </div>
        <div style="margin-top: -15px">
          <p>
            <b>Modo / Época de aplicação</b>
            {{ item.descModoAplicacao }}
          </p>
        </div>
        <div>
          <p>
            <b>Equipamento de Proteção Individual (EPI) USO OBRIGATÓRIO</b>
            {{ item.descEpi }}
          </p>
        </div>
        <div>
          <p>
            <b>Precauções de Uso</b>
            {{ item.descPrecaucaoUso }}
          </p>
        </div>
        <div v-if="item.obs">
          <p>
            <b>OBSERVAÇÕES</b>
            {{ item.obs }}
          </p>
        </div>
      </div>
      <div class="dashed-box">
        <h2><b>ORIENTAÇÕES QUANTO AO MANEJO INTEGRADO DE PRAGAS E DE RESISTÊNCIA</b></h2>
        <p>
          Realizar o manejo integrado de pragas e resistência. Adotar medidas
          favoráveis que visem a redução ou o controle populacional do problema
          fitossanitário compondo um programa de manejo integrado
        </p>
      </div>
      <div class="dashed-box">
        <h2><b>DESTINAÇÃO FINAL DOS RESÍDUOS E EMBALAGENS VAZIAS</b></h2>
        <p>
          É proibido reutilizar as embalagens de agrotóxicos e afins. As
          embalagens rígidas que contiverem formulações miscíveis ou dispersíveis
          em água deverão ser submetidas pelo usuário à operação de tríplice
          lavagem, ou tecnologia equivalente, conforme normas técnicas oriundas
          dos órgãos competentes e orientação constante de seus rótulos e bulas.
          Os usuários deverão efetuar a devolução das embalagens vazias em postos
          ou centros de recolhimentos, de acordo com as instruções previstas nas
          respectivas bulas, no prazo de até um ano, contado da data de compra.
          (Lei n. 9.974/00, Decreto Federal n.° 4.074/02). </p><b>Local para entrega das embalagens:</b>
        {{
          configuracao.frase_unidade_recebimento == undefined ||
            configuracao.frase_unidade_recebimento.length == 0
            ? receita.unidRecebimento
            : configuracao.frase_unidade_recebimento
        }}
      </div>
      <footer class="footer-receita" :style="receita.itens == 1 ? 'margin-top: 100px;' : 'margin-top: 40px;'">
        <h2>LEIA ATENTAMENTE O RÓTULO E BULA DO PRODUTO. AGRICULTOR, AGROTÓXICO É
          VENENO.</h2>
        <div class="card" :style="receita.is_sign_produtor ? 'display:none;' : 'display:block;'">
          <p>
            <b>Estou ciente das informações contidas nesta receita e seu anexo.</b>
          </p>
          <div class="assinatura mt-4 pt-2">
            <p>
              <b>{{ receita.nomeProdutor }}</b>
            </p>
          </div>
          <div class="card-footer-receita">
            <div>
              <p> <b>CPF/CNPJ: </b>{{ receita.cpfCnpjProdutor }} </p>
              <p>
                <b>Data:</b> {{ formatDate(receita.dataEmissao) }} /
                <b>Cidade/UF:</b> {{ receita.municipio }} /
                {{ receita.estado }}
              </p>
            </div>
          </div>
        </div>
        <div :class="receita.is_sign_produtor ? 'card col-6' : 'card'">
          <div v-show="isSignature || empresa.is_signature">
            <img v-if="checkBase64()" :src="receita.assinatura" alt="assinatura"
              style="max-height: 100%; height: auto; position: absolute; bottom: 30px; left: 50%; transform: translateX(-50%); z-index: 20000;" />
            <label v-else class="sig3 mt-2">{{ receita.assinatura }}</label>
          </div>

          <div class="assinatura">
            <p>{{ receita.nomeAgronomo }}</p>
          </div>
          <div class="card-footer-receita">
            <div>
              <p> <b>Título do profissional:</b> {{ receita.profissao }} </p>
              <p>
                <b v-if="empresa.id_empresa_sistema !== 139 && empresa.id_empresa_sistema !== 140">CPF:</b>
                <span v-if="empresa.id_empresa_sistema !== 139 && empresa.id_empresa_sistema !== 140"> {{ receita.cpf }} </span>
                <span>
                  <b>{{ isAgronomo(receita.profissao) ? 'CREA' : 'CFTA' }}:</b> {{ receita.crea }}
                </span>
              </p>
              <p> </p>
            </div>
          </div>
        </div>
      </footer>
    </div>


    <loading :active.sync="isLoading" color="#008e75" :can-cancel="true" :is-full-page="true"></loading>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay'
import VueHtml2pdf from 'vue-html2pdf'
import moment from 'moment'
moment.locale('pt-br')
import receita1Item from '@/src/components/rel-receita-1-2-itens.vue'
import receita4Item from '@/src/components/rel-receita-3-4-itens.vue'
import receita5Item from '@/src/components/rel-receita-5-itens.vue'
import receita6Item from '@/src/components/rel-receita-6-itens.vue'
import receita7Item from '@/src/components/rel-receita-7-itens.vue'
import receita8Item from '@/src/components/rel-receita-8-itens.vue'
import receita9Item from '@/src/components/rel-receita-9-itens.vue'
import receita10Item from '@/src/components/rel-receita-10-itens.vue'
import receita11Item from '@/src/components/rel-receita-11-itens.vue'
import receita12Item from '@/src/components/rel-receita-12-itens.vue'
import receita13Item from '@/src/components/rel-receita-13-itens.vue'
import receita14Item from '@/src/components/rel-receita-14-itens.vue'
import receitaCeagesp from '@/src/components/rel-receita-ceagesp.vue'
import receitaPr from '@/src/components/rel-receita-pr.vue'
import receitaComplementar from '@/src/components/rel-receita-complementar.vue'
import ipService from '@/src/services/get-ip'
import receitaService from '@/src/services/receita'
import axios from 'axios'

export default {
  components: {
    Loading,
    VueHtml2pdf,
    receita1Item,
    receita4Item,
    receita5Item,
    receita6Item,
    receita7Item,
    receita8Item,
    receita9Item,
    receita10Item,
    receita11Item,
    receita12Item,
    receita13Item,
    receita14Item,
    receitaCeagesp,
    receitaPr,
    receitaComplementar
  },
  props: {
    receita: {},
    empresa: {},
    isSignature: false,
    urlPdf: undefined,
  },
  data() {
    return {
      isLoading: false,
      textColor: 'blue',
      arquivoPdf: {
        url: '',
        label: '',
      },
      color: 'red',
      htmlToPdfOptions: {
        filename: `receita-${this.receita.ultimaReceitaEmitida}.pdf`,
        margin: [8, 10, 8, 10],
        image: {
          type: 'jpeg',
          quality: 0.75,
        },
        html2canvas: {
          scale: 2,
          logging: true,
          dpi: 192,
          letterRendering: true,
        },
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: 'portrait',
          compressPDF: true,
        },
      },
      configuracao: {},
    }
  },
  watch: {},
  created() { },
  mounted() {
    this.$root.$on('print-receita', () => {
      if (this.empresa.id_empresa_sistema == 45454545 || this.empresa.id_empresa_sistema == 101) {
        this.emitirReceitaV2();
        return;
      }

      if (!this.isSignature) {
        this.generateReport()
        return
      }
      if (this.urlPdf == undefined && this.isSignature) {
        this.generateReport()
        return
      }
    })
    this.configuracao = JSON.parse(window.localStorage.getItem('configuracao'))
    console.log(this.configuracao);
  },
  computed: {},
  methods: {
    async emitirReceitaV2() {
      try {
        const token = this.$store.state.auth.currentUser.token
        const response = await receitaService.emitirReceitaV2(token, this.receita);
        this.downloadItem({
          url: response.data.url,
          label: response.data.label,
        })
        this.$bvToast.toast('Receituário gerado sucesso!', {
          variant: 'success',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      } catch (emailError) {
        console.error(emailError);
        this.$bvToast.toast('Falha ao gerar receituário.', {
          variant: 'danger',
          solid: true,
          noCloseButton: false,
          toaster: 'b-toaster-top-center',
        });
      }
    },
    isAgronomo(prof) {
      if (!prof) return false

      const p = prof
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()

      // cobre agrônomo/agrônoma em qualquer variação
      return /agronom/.test(p)
    },
    getCategoria(tipoAplicacao) {
      if (!tipoAplicacao) return '';

      const tipo = tipoAplicacao.toLowerCase();

      if (tipo.includes('aérea') || tipo.includes('drone')) {
        return 'Aérea';
      } else if (
        tipo.includes('isca') ||
        tipo.includes('semente') ||
        tipo.includes('sementes') ||
        tipo.includes('armadilhas') ||
        tipo.includes('fumigação')
      ) {
        return 'Outros';
      } else if (tipo.includes('pulverização')) {
        return 'Terrestre';
      } else {
        return '';
      }
    },
    removerParteInteiraSeZero(value) {
      if (!isNaN(value)) {
        const parteInteira = parseInt(value);
        const parteDecimal = parseFloat(value.toString().split('.')[1]);

        if (parteInteira === 0) {
          return parteDecimal !== undefined ? parteDecimal : value;
        } else {
          return value;
        }
      }
      return value;
    },
    getAreaAplicacaoMeta(item) {
      const unidadeCalda = String(item && item.unidadeCalda ? item.unidadeCalda : '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
      const unidadeDose = String(item && item.unidadeDose ? item.unidadeDose : '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()

      const dosePorHectare =
        unidadeDose.includes('/ha') ||
        unidadeDose.includes(' ha') ||
        unidadeDose.includes('hectare')

      if (
        (unidadeCalda.includes('l/planta') ||
          unidadeCalda.includes('ml/planta') ||
          unidadeCalda.includes('por planta') ||
          unidadeCalda.includes('planta')) &&
        !dosePorHectare
      ) {
        return { label: 'Quantidade tratada', unit: 'plantas' }
      }

      if (
        unidadeCalda.includes('m3') ||
        unidadeCalda.includes('m³') ||
        unidadeCalda.includes('metro cubico') ||
        unidadeCalda.includes('metros cubicos')
      ) {
        return { label: 'Volume tratado', unit: 'm³' }
      }

      return { label: 'Área tratada', unit: 'ha' }
    },
    getAreaAplicacaoLabel(item) {
      return this.getAreaAplicacaoMeta(item).label
    },
    getAreaAplicacaoUnit(item) {
      return this.getAreaAplicacaoMeta(item).unit
    },
    getFirstObs(items) {
      const itemWithObs = items.find(item => item.obs !== null && item.obs !== undefined);

      if (itemWithObs) {
        return itemWithObs.obs;
      } else {
        return '';
      }
    },
    async downloadItem({ url, label }) {
      // const response = await fetch(url, {
      //   method: 'GET',
      //   headers: {
      //     'Content-Type': 'application/pdf'
      //   }
      // });

      // const blob = await response.blob();
      // const link = document.createElement('a');
      // link.href = URL.createObjectURL(blob);
      // link.download = label;
      // link.click();
      // URL.revokeObjectURL(link.href);
      // const pdfUrl = window.URL.createObjectURL(response.data);
      const urlComTimestamp = `${url}?t=${new Date().getTime()}`;
      window.open(urlComTimestamp, '_blank');
    },
    formatDate(date) {
      return moment.utc(date).format('DD/MM/YYYY')
    },
    formatDateTime(date) {
      return moment.utc(date).format('YYYY/MM/DD HH:mm:ss')
    },
    formatCpf(cpf) {
      if (!cpf) return ''

      const digits = String(cpf).replace(/\D/g, '')

      if (digits.length !== 11) return cpf

      return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    },
    async generateReport() {
      await this.$refs.html2Pdf.generatePdf()
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      const vue = this

      if (this.empresa.is_signature) {
        await html2pdf()
          .set(options)
          .from(pdfContent)
          .toPdf()
          .output('datauristring')
          .then(function (pdfAsString) {
            vue.noSignRevenue(pdfAsString)
          })
        return
      }
      if (this.isSignature) {
        await html2pdf()
          .set(options)
          .from(pdfContent)
          .toPdf()
          .output('datauristring')
          .then(function (pdfAsString) {
            vue.signRevenue(pdfAsString)
          })
        return
      }
      this.isLoading = true
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get('pdf')
        .then((pdf) => {
          vue.isLoading = false
        })
        .save()
    },

    async signRevenue(base64) {
      this.isLoading = true
      const responseIp = await ipService.getIp()
      var local = `${responseIp.data.city} - ${responseIp.data.region} - ${responseIp.data.country}`
      let dataForm = new FormData()
      dataForm.append('idReceita', this.receita.idReceita)
      dataForm.append('idAgronomo', this.receita.idAgronomo)
      dataForm.append('local', local)
      dataForm.append('ip', responseIp.data.ip)
      dataForm.append(
        'base64',
        base64.replace('data:application/pdf;base64,', '')
      )

      const token = this.$store.state.auth.currentUser.token
      const responseSignRevenue = await receitaService.signDigital(
        token,
        dataForm
      )
      this.arquivoPdf.url = responseSignRevenue.data.url
      this.arquivoPdf.label = `receita-${this.receita.ultimaReceitaEmitida}.pdf`
      this.downloadItem({
        url: this.arquivoPdf.url,
        label: this.arquivoPdf.label,
      })
      this.isLoading = false
    },

    async noSignRevenue(base64) {
      this.isLoading = true
      const responseIp = await ipService.getIp()
      var local = `${responseIp.data.city} - ${responseIp.data.region} - ${responseIp.data.country}`
      let dataForm = new FormData()
      dataForm.append('idReceita', this.receita.idReceita)
      dataForm.append('idAgronomo', this.receita.idAgronomo)
      dataForm.append('local', local)
      dataForm.append('ip', responseIp.data.ip)
      dataForm.append(
        'base64',
        base64.replace('data:application/pdf;base64,', '')
      )

      const token = this.$store.state.auth.currentUser.token
      const responseSignRevenue = await receitaService.noSignDigital(
        token,
        dataForm
      )
      this.arquivoPdf.url = responseSignRevenue.data.url
      this.arquivoPdf.label = `receita-${this.receita.ultimaReceitaEmitida}.pdf`
      this.downloadItem({
        url: this.arquivoPdf.url,
        label: this.arquivoPdf.label,
      })
      this.isLoading = false

      // 6️⃣ Envia o e-mail ao produtor com a receita gerada
      console.log('passou aqui');
      console.log(this.empresa);
      if (this.empresa.id_empresa_sistema == 12) {
        try {
          await receitaService.enviarEmailReceita(token, this.receita.idReceita);
          this.$toast.success('Receita enviada por e-mail ao produtor com sucesso!');
        } catch (emailError) {
          console.error(emailError);
          this.$toast.error('Falha ao enviar a receita por e-mail.');
        }
      }
    },

    checkBase64() {
      const v = this.receita.assinatura;
      if (typeof v !== 'string') return false;

      const m = v.match(/^data:image\/(png|jpe?g|gif|webp);base64,([A-Za-z0-9+/=]+)$/i);
      if (!m) return false;

      const mime = m[1].toLowerCase();
      const b64 = m[2];

      if (b64.length < 24) return false;

      try {
        const bin = atob(b64);

        const head = bin.slice(0, 8);

        if (mime === 'png') {
          return head.charCodeAt(0) === 0x89 &&
            head[1] === 'P' && head[2] === 'N' && head[3] === 'G';
        }
        if (mime === 'jpg' || mime === 'jpeg') {
          return head.charCodeAt(0) === 0xFF && head.charCodeAt(1) === 0xD8;
        }
        if (mime === 'gif') {
          return head.startsWith('GIF87a') || head.startsWith('GIF89a');
        }
        if (mime === 'webp') {
          return bin.startsWith('RIFF') && bin.slice(8, 12) === 'WEBP';
        }

        return true;
      } catch (e) {
        return false;
      }
    },
  },
}
</script>

<style scoped>
body {
  width: 1240px;
  height: 1754px;
  margin: auto;
  font-size: 1em;
  font-family: sans-serif;
}

.logo {
  text-align: left;
  color: #bbb;
}

.logo {
  width: 130px;
  margin: 0;
}

.container {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
}

.container div {
  padding: 5px 0;
}

.header-page2 {
  display: flex;
  padding: 0px 0;
}

.header-page2 div {
  border: 2px solid #000;
  padding: 5px 5px 5px 5px;
}

.header-page2 div:nth-of-type(1) {
  width: 50%;
  margin-right: 2%;
}

.header-page2 div:last-child {
  flex-grow: 1;
}

.header {
  display: flex;
  padding: 0px 0;
}

.header div {
  border: 2px solid #000;
  padding: 5px 5px 5px 5px;
}

.header div:nth-of-type(1) {
  width: 50%;
  margin-right: 2%;
}

.header div:last-child {
  flex-grow: 1;
}

.header .header-page2,
.dashed-box,
.footer-receita {
  position: relative;
}

div h1 {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  background-color: #fff;
  width: fit-content;
  font: bold 19px 'Helvetica';
  line-height: 22px;
}

div h2 {
  position: absolute;
  top: -20px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 0.9em;
  background-color: #fff;
  width: fit-content;
  padding: 0 20px;
}

div h3 {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  background-color: #fff;
  width: fit-content;
  padding: 0 20px;
  font: bold 16px 'Helvetica';
  line-height: 19px;
}

div p {
  margin: 0;
  padding: 2px;
  font: 11px 'Helvetica';
}

.dashed-box {
  border-top: 1px dashed #000;
}

.dashed-box:nth-of-type(1),
.dashed-box:nth-of-type(2) {
  line-height: 1em;
  display: flex;
  justify-content: flex-start;
  padding-right: 40px;
}

.dashed-box:nth-of-type(1) div:nth-child(2) {
  width: 65%;
}

.dashed-box:nth-of-type(2) div:nth-child(2) {
  width: 70%;
}

.dashed-box:nth-of-type(2) div:nth-child(3) {
  width: 35%;
}

.footer-receita {
  display: flex;
  padding: 10px 0;
}

.footer-receita .card {
  border: 2px solid #000;
  width: 60%;
  text-align: center;
  font-size: 9px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.footer-receita .card:nth-of-type(1) {
  margin-right: 3%;
}

.assinatura {
  width: 90%;
  height: 10px;
  margin: auto;
  border-bottom: 2px solid black;
  position: relative;
  flex-grow: 1;
}

.assinatura p {
  padding: 0;
  margin: 0;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  bottom: -20px;
}

.card-footer-receita {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-right: 10px;
}

.card-footer-receita div {
  margin-top: 15px;
  text-align: left;
  padding: 0 5px;
}

.card-footer-receita p {
  margin: 0;
  padding: 0;
}

.print-p {
  font: 9px;
}

@media print {
  body {
    width: 100%;
    height: 100%;
    font-size: 0.8em;
  }

  .container {
    margin-top: 50px;
    display: flex;
    flex-direction: column;
  }

  .container div {
    padding: 0;
    font-size: 0.7em;
  }

  div h2 {
    top: -12px;
    font-size: 0.9em;
  }

  .footer-receita {
    margin-top: 280px;
  }

  .footer-receita h2 {
    font-size: 0.7em;
  }

  .footer-receita .card {
    font-size: 0.6em;
    padding: 0 0 15px 0;
  }

  .assinatura {
    height: 15px;
  }

  .assinatura p {
    bottom: -10px;
  }
}

.vld-overlay.is-full-page {
  z-index: 999;
  position: fixed;
}
</style>
